<template>
    <div>
        <h2>{{ store.lexicon[store.culture].PRFormRequestorInfo }}</h2>

        <div class="row">
            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PRFormName }}<span class="required">*</span></label>
                <input type="text" class="form-control" v-model="store.formData.FirstName" @input="validatePage('REQUESTOR', 'firstName')" />
                <div v-if="store.errors.FirstName" class="error">{{ store.lexicon[store.culture].PRFormName2 }}</div>
            </div>
            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PRFormName3 }}<span class="required">*</span></label>
                <input type="text" class="form-control" v-model="store.formData.LastName" @input="validatePage('REQUESTOR', 'lastName')" />
                <div v-if="store.errors.LastName" class="error">{{ store.lexicon[store.culture].PRFormName4 }}</div>
            </div>
        </div>
        <div class="form-group">
            <label>{{ store.lexicon[store.culture].PRFormOrg }}</label>
            <input type="text" class="form-control" v-model="store.formData.Organization" />
        </div>
        <div class="row">
            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PRFormPhone }}</label>
                <input type="text" class="form-control" v-model="store.formData.PhoneNumber" @blur="validatePage('REQUESTOR', 'phoneNumber')" />
                <div>{{ store.lexicon[store.culture].PRFormPhone1 }}</div>
                <div v-if="store.errors.PhoneNumber" class="error">{{ store.lexicon[store.culture].PRFormPhone2 }}</div>
            </div>
            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PRFormEmail }}<span class="required">*</span></label>
                <input type="text" class="form-control" v-model="store.formData.Email" @blur="validatePage('REQUESTOR', 'email')" />
                <div v-if="store.errors.Email" class="error">{{ store.lexicon[store.culture].PRFormEmail2 }}</div>
            </div>
        </div>
        <div class="text-center">
            <button type="button" class="btn btn-primary" @click="goToPage('BACKGROUND')">{{ store.lexicon[store.culture].Next }}</button>
        </div>
    </div>
</template>

<script setup>
    import { useStore } from './store.js';

    const emit = defineEmits(['goToPage', 'goBackToPage', 'validatePage']);

    const store = useStore();

    function goToPage(pageName) {
        emit('goToPage', pageName);
    }

    function goBackToPage(pageName) {
        emit('goBackToPage', pageName);
    }

    function validatePage(pageName, fieldName) {
        emit('validatePage', pageName, fieldName);
    }

</script>